module.exports = __webpack_public_path__ + "img/SES_140250052.0cb1384a.jpg";